import {
  idlFactory as resolverIDL,
  _SERVICE as ResolverActor
} from '@icnaming/resolver_client';

import { AuthBase } from '../AuthBase';
import { CanisterError } from '../exception';
import * as ResolverKeys from '../config/ResolverKey';

export type ResolverKey = typeof ResolverKeys[keyof typeof ResolverKeys];

export class Resolver extends AuthBase {
  private resolverCanisterId: string;

  constructor(resolverCanisterId: string) {
    super();
    this.resolverCanisterId = resolverCanisterId;
  }

  /**
   * get name record values
   */
  public async getRecordValues(name: string) {
    const resolver = this.createResolverActor(
        this.resolverCanisterId
    );
    const res = await resolver.get_record_value(name);
    
    if ('Ok' in res) return res.Ok;

    throw new CanisterError(res.Err);
  }


  private createResolverActor(resolverCanisterId: string) {
    return this.createActorWithAnonymousIdentity<ResolverActor>(
      resolverCanisterId,
      resolverIDL
    );
  }
}
